import { render, staticRenderFns } from "./EmbedChatView.vue?vue&type=template&id=9c700d4c&"
import script from "./EmbedChatView.vue?vue&type=script&lang=js&"
export * from "./EmbedChatView.vue?vue&type=script&lang=js&"
import style0 from "./EmbedChatView.vue?vue&type=style&index=0&id=9c700d4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports